var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM9.70696 6.58071C9.70696 6.28083 9.88363 6.0604 10.0603 6.0604H11.4546V4.5H10.0603C8.90212 4.5 8.03838 5.50063 8.03838 6.74013V7.6003H6.54547V9.08022H8.03838V13.5H9.70696V9.08022H11.4546V7.6003H9.70696V6.58071Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
